import React from 'react'

import { Option } from './styles'

export default function CustomOption({
    innerRef, innerProps, isDisabled, children 
}) {
    return isDisabled ? null : <Option ref={innerRef} {...innerProps}>{children}</Option>
}
